<div class="dashboard-content" style="padding: 120px 40px 50px">

  <section>
    <div class="contests-back-icon" routerLink="/home/analytic">
      <span class="back-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
          <rect width="52" height="52" rx="26" fill="#F5F5F9" />
          <path d="M18 26H34" stroke="#586277" stroke-width="1.53752" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M23 31C23 31 18 27.3176 18 26C18 24.6824 23 21 23 21" stroke="#586277" stroke-width="1.53752"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
    </div>

    <div class="row contests-container analysis-contests-container">
      <div class="col-12">
        <div class="contests-header d-flex justify-content-between align-items-center">
          <h1>{{ "contestMonitoring.heading" | translate }}</h1>
        </div>
      </div>

      <div class="col-12">
        <div class="content-card" style="background-color: white">
          <div class="head">
            <div class="heading">
              <div class="users">
                <!-- <div class="profiles">
                <img src="assets/images/l1.png" class="logo" alt="" />
                <img src="assets/images/l2.png" class="logo" alt="" />
                <img src="assets/images/l3.png" class="logo" alt="" />
              </div> -->
                <div class="contests-header d-flex justify-content-between align-items-center">
                  <h1>Contest Report</h1>
                </div>
              </div>

              <div class="d-flex align-items-center gap-3 mt-3">
                <div class="filter-container d-flex align-items-center gap-3 position-relative">
                  <div class="search-box position-relative w-100">
                    <input type="text" placeholder="Search contests" class="form-control" [(ngModel)]="searchTerm"
                      (input)="onSearch($event)" autocapitalize="off" style="text-transform: none;" />

                    <!-- Filter Icon -->
                    <span class="filter-icon position-absolute" (click)="openFilterModal()" style="
                    top: 50%;
                    right: 14px;
                    transform: translateY(-50%);
                    cursor: pointer;
                  ">
                      <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 3.5625H3.56248" stroke="white" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M1 12.1045H6.12497" stroke="white" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M13.8126 12.1045H16.375" stroke="white" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path d="M11.2501 3.5625H16.375" stroke="white" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path
                          d="M3.5625 3.56248C3.5625 2.76651 3.5625 2.36852 3.69254 2.05457C3.86592 1.63599 4.19849 1.30342 4.61707 1.13004C4.93102 1 5.32901 1 6.12498 1C6.92096 1 7.31893 1 7.63292 1.13004C8.05146 1.30342 8.38407 1.63599 8.55746 2.05457C8.68747 2.36852 8.68747 2.76651 8.68747 3.56248C8.68747 4.35846 8.68747 4.75645 8.55746 5.07039C8.38407 5.48897 8.05146 5.82154 7.63292 5.99493C7.31893 6.12497 6.92096 6.12497 6.12498 6.12497C5.32901 6.12497 4.93102 6.12497 4.61707 5.99493C4.19849 5.82154 3.86592 5.48897 3.69254 5.07039C3.5625 4.75645 3.5625 4.35846 3.5625 3.56248Z"
                          stroke="white" stroke-width="1.5" />
                        <path
                          d="M8.6875 12.1045C8.6875 11.3085 8.6875 10.9105 8.8175 10.5965C8.9909 10.178 9.32351 9.84539 9.74205 9.672C10.056 9.54199 10.454 9.54199 11.25 9.54199C12.046 9.54199 12.4439 9.54199 12.7579 9.672C13.1765 9.84539 13.5091 10.178 13.6825 10.5965C13.8125 10.9105 13.8125 11.3085 13.8125 12.1045C13.8125 12.9005 13.8125 13.2984 13.6825 13.6124C13.5091 14.0309 13.1765 14.3636 12.7579 14.537C12.4439 14.667 12.046 14.667 11.25 14.667C10.454 14.667 10.056 14.667 9.74205 14.537C9.32351 14.3636 8.9909 14.0309 8.8175 13.6124C8.6875 13.2984 8.6875 12.9005 8.6875 12.1045Z"
                          stroke="white" stroke-width="1.5" />
                      </svg>
                    </span>

                    <!-- Cross Icon (Clear) -->
                    <span *ngIf="hasActiveFilters() || searchTerm"
                      class="position-absolute d-flex justify-content-center align-items-center pulse-badge"
                      (click)="clearAllFilters()">
                      ✕
                    </span>
                  </div>
                </div>


                <div class="dropdown export-dropdown">
                  <button class="Download-button dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff"
                      fill="none">
                      <path
                        d="M18.25 8.99997C20.3077 9.07357 22.0549 10.6169 21.9987 12.6843C21.9856 13.1653 21.7993 13.7598 21.4266 14.9488C20.5298 17.8104 19.0226 20.2944 15.6462 20.8904C15.0255 21 14.3271 21 12.9303 21H11.0697C9.6729 21 8.9745 21 8.35384 20.8904C4.97739 20.2944 3.47018 17.8104 2.57336 14.9488C2.20072 13.7598 2.01439 13.1653 2.00132 12.6843C1.94512 10.6169 3.6923 9.07357 5.75001 8.99997"
                        stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path>
                      <path
                        d="M12 14L12 3M12 14C11.2998 14 9.99153 12.0057 9.5 11.5M12 14C12.7002 14 14.0085 12.0057 14.5 11.5"
                        stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <span>{{ "contestMonitoring.excel" | translate }}</span>
                    <i class="fa-solid fa-angle-down ms-2"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)" (click)="downloadPDF()">
                        <i class="fa-solid fa-file-pdf me-2" style="color: #e74c3c;"></i>
                        PDF
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)" (click)="downloadExcel()">
                        <i class="fa-solid fa-file-excel me-2" style="color: #27ae60;"></i>
                        Excel
                      </a>
                    </li>
                  </ul>
                </div>






              </div>
            </div>

            <!-- Dynamic Statistics Cards -->
            <!-- Dynamic Statistics Cards -->
            <div class="cards-container">
              <div class="card" *ngFor="let item of contest_monitoring">
                <div class="card-title">
                  <p class="icon">
                    <img *ngIf="item.icon" [src]="item.icon" width="40" height="40" />
                  </p>
                  <span class="title">{{ item.title | translate }}</span>
                </div>
                <p class="number">{{ item.displayNumber }}</p>
                <div class="progress-content">
                  <!-- Positive percentage -->
                  <p class="increase" *ngIf="item.percentage > 0">
                    <i class="fa-solid fa-arrow-up"></i>
                    <span>{{ item.percentage }}%</span>
                  </p>
                  <!-- Negative percentage -->
                  <p class="decrease" *ngIf="item.percentage < 0">
                    <i class="fa-solid fa-arrow-down"></i>
                    <span>{{ Math.abs(item.percentage) }}%</span>
                  </p>
                  <!-- Zero percentage -->
                  <p class="neutral" *ngIf="item.percentage === 0">
                    <span>0%</span>
                  </p>
                  <!-- Dynamic text based on filter -->
                  <p class="progress-text">
                    {{ selectedTimeFilter === 'week' ? 'vs last week' :
                    selectedTimeFilter === 'month' ? 'vs last month' :
                    'vs last year' }}
                  </p>
                </div>
              </div>
            </div>
            <!-- Table Header -->
            <div class="d-flex align-items-center justify-content-between">
              <div class="contests-header d-flex justify-content-between align-items-center">
                <h1>{{ "contestMonitoring.all_contest" | translate }}</h1>
              </div>


            </div>

            <!-- Table Content -->
            <div class="table-content mt-3">
              <div class="table">
                <nz-table [nzFrontPagination]="false" [nzData]="listOfData" [nzTotal]="totalRecords"
                  [nzPageSize]="pageSize" [nzPageIndex]="currentPage" (nzPageIndexChange)="onPageChange($event)"
                  [nzScroll]="{ x: '1800px' }">
                  <thead>
                    <tr>
                      <th *ngFor="let col of columns" [style.width]="col.width" [nzRight]="col.fixed === 'right'">
                        {{ col.name | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of listOfData">
                      <td class="truncate-cell">
                        <div class="tooltip-container" (mouseenter)="onMouseEnter($event, data.contestName)"
                          (mouseleave)="onMouseLeave($event)">
                          <span>
                            {{
                            data.contestName?.length > 12
                            ? (data.contestName | slice: 0:8) + '…'
                            : data.contestName
                            }}
                          </span>
                          <div class="custom-tooltip" *ngIf="data.contestName?.length > 12">
                            {{ data.contestName }}
                          </div>
                        </div>
                      </td>


                      <td>
                        {{ data.contestFormat }}

                      </td>

                      <td>{{ data.contestType }}</td>
                      <td>{{ data.numberOfLevels }}</td>

                      <td class="truncate-cell">
                        <div class="tooltip-container" (mouseenter)="onMouseEnter($event, data.location)"
                          (mouseleave)="onMouseLeave($event)">
                          <span>
                            {{
                            data.location?.length > 12
                            ? (data.location | slice: 0:8) + '…'
                            : data.location
                            }}
                          </span>
                          <div class="custom-tooltip" *ngIf="data.location?.length > 12">
                            {{ data.location }}
                          </div>
                        </div>
                      </td>

                      <td class="truncate-cell">
                        <div class="tooltip-container" (mouseenter)="onMouseEnter($event, data.prize)"
                          (mouseleave)="onMouseLeave($event)">
                          <span>
                            {{
                            data.prize?.length > 12
                            ? (data.prize | slice: 0:8) + '…'
                            : data.prize
                            }}
                          </span>
                          <div class="custom-tooltip" *ngIf="data.prize?.length > 12">
                            {{ data.prize }}
                          </div>
                        </div>
                      </td>
                      <td>{{ data.gender }}</td>
                      <td class="truncate-cell">
                        <div class="tooltip-container">
                          <span>
                            {{
                            data.ageBreakdown?.length > 12
                            ? (data.ageBreakdown | slice: 0:8) + '…'
                            : data.ageBreakdown
                            }}
                          </span>
                          <div class="custom-tooltip" *ngIf="data.ageBreakdown?.length > 12">
                            {{ data.ageBreakdown }}
                          </div>
                        </div>
                      </td>

                      <td nzRight>
                        <div class="d-flex justify-content-center">
                          <svg style="cursor: pointer" (click)="viewDetail(data.id)" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24" width="28" height="28" color="#4a4a4a" fill="none">
                            <path d="M16.5 7.5L6 18" stroke="#4a4a4a" stroke-width="2" stroke-linecap="round"></path>
                            <path
                              d="M8 6.18791C8 6.18791 16.0479 5.50949 17.2692 6.73079C18.4906 7.95209 17.812 16 17.812 16"
                              stroke="#4a4a4a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <app-filter-modal [(isVisible)]="filterModalVisible" [config]="filterConfig" [initialFilters]="currentFilters"
    (filtersApplied)="onFiltersApplied($event)" (filtersReset)="onFiltersReset()"></app-filter-modal>
</div>